import { cn } from '@bem-react/classname';

export const cnSelectPositionWrapper = cn('SelectPositionWrapper');

export namespace NSelectPositionWrapper {

    export interface Props {

    }
}